import { useLocalStorage } from "usehooks-ts";
import { IS_FORCED_VIDEO_PLATFORM_DOWNGRADE_KEY } from "../config";

export function useIsVideoPlatformDowngraded() {
  return useLocalStorage<boolean | undefined>(
    IS_FORCED_VIDEO_PLATFORM_DOWNGRADE_KEY,
    undefined,
  );
}
